import React, { Component } from 'react';
import SvgIcon              from 'material-ui/SvgIcon';
import './../css/LoadingSvg.css';

class LoadingSvg extends Component
{
    render = () =>
    {
        return (
            <div className="center" style={ this.props.style }>
                <SvgIcon className="spinner" style={{ width: '34px', height: '34px' }} viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg">
                    <circle className="path" fill="none" strokeWidth="4" strokeLinecap="round" cx="17" cy="17" r="15"/>
                </SvgIcon>
            </div>
        );
    }
}

LoadingSvg.defaultProps = {
    style: null
};

export default LoadingSvg;


// WEBPACK FOOTER //
// ./src/components/LoadingSvg.js